import { Controller } from "@hotwired/stimulus"

// Klappt die Filter-Eingabezeile (Pillen + Dynamic-Rows + 'Filter hinzufuegen')
// ein und aus. Chips darunter bleiben immer sichtbar — der User weiss, was
// aktiv ist, auch wenn die Leiste collapsed ist. Zustand pro Resource im
// localStorage gemerkt, damit die Praeferenz Navigation ueberlebt.
//
// Targets:
//   inputRow      — .filter-bar-toggleable (auf separater Seite gerendert)
//   toggleButton  — der Sliders-Icon-Button (visueller State)
export default class extends Controller {
  static targets = ["toggleButton"]

  connect() {
    this.storageKey = `filter-bar-collapsed:${window.location.pathname}`
    this.inputRow = document.querySelector(".filter-bar-toggleable")
    if (!this.inputRow) return

    const stored = localStorage.getItem(this.storageKey)
    if (stored === "1") this.applyCollapsed(true)
  }

  toggle() {
    if (!this.inputRow) return
    const wasHidden = this.inputRow.classList.contains("hidden")
    this.applyCollapsed(!wasHidden)
    localStorage.setItem(this.storageKey, wasHidden ? "0" : "1")
  }

  applyCollapsed(collapsed) {
    if (!this.inputRow) return
    this.inputRow.classList.toggle("hidden", collapsed)
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.classList.toggle("bg-gray-100", collapsed)
      this.toggleButtonTarget.classList.toggle("text-gray-700", collapsed)
    }
  }
}
